<template lang="pug">
.productinfo
    .md-layout.md-gutter.md-alignment-top-left(v-if="products.length > 0")
        .md-layout-item.md-size-33.md-small-size-100(v-for="(product, idx) in products" :key="idx")
            pack-shot(:product="product" ref="packShot" )
    .md-layout.md-gutter.md-alignment-top-left(v-else)
        .md-layout-item.md-size-100
            md-empty-state(:md-label="label" :md-description="description")
</template>
<script>

export default {
  components: {
    PackShot: () => import('@/components/PackShot')
  },
  props: ['products', 'label', 'description'],
  methods: {
    async productInfoTable () {
      if (this.products.length === 0) {
        return
      }
      var promises = []
      var self = this
      promises.push([{ text: this.label, alignment: 'left', colSpan: 2, fontSize: 12 }, {}])
      self.$refs.packShot.filter(shot => !!shot.packShot).forEach(
        obj => {
          promises.push(obj.getBase64())
        })
      let result = await Promise.all(promises)
      let table = {
        table: {
          headerRows: 1,
          widths: ['auto', '*'],
          body: result
        },
        layout: 'headerLineOnly'
      }
      return table
    }
  }
}
</script>
  <style scoped>
.md-empty-state {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductInfo.vue